<header class="header" [class.scrolled]="isScrolled">
  <div class="container">
    <div class="header-content">
      <div class="logo">
        <a routerLink="/" class="logo-link">
          <img src="assets/logo/MitraLogo.svg" alt="Mitra Sanitär Logo" class="company-logo">
        </a>
      </div>
      <app-navigation></app-navigation>
    </div>
  </div>
</header>